export class SalesReportRecordThisYear {
    constructor(
        public bookings: number,
        public weeks: number,
        public bookingsLastYear: number,
        public weeksLastYear: number,
        public salesAgentName: string
    ){}
}
